export interface MangaCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export interface MangaItem {
  slug: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  categories: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: number;
  updatedAt: string;
  chapters_list: MangaChapter[];
  tags: string[];
}

export interface MangaChapter {
  id: number;
  title: string;
  updatedAt: string;
  pages: number;
}

export const mangaCategories: MangaCategory[] = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', description: '燃爆热血，激情对决，战斗冒险类漫画' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫，心动日常，青春恋爱物语' },
  { slug: 'xuanhuan', name: '玄幻', icon: 'ri-magic-line', description: '奇幻世界，修仙斗法，东方玄幻佳作' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '爆笑日常，欢乐无限，轻松幽默漫画' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '烧脑推理，惊险刺激，悬疑侦探漫画' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', description: '未来世界，科技幻想，星际冒险旅程' },
  { slug: 'dushi', name: '都市', icon: 'ri-building-line', description: '现代都市，人生百态，职场生活漫画' },
  { slug: 'gufeng', name: '古风', icon: 'ri-ancient-gate-line', description: '古韵风华，历史架空，唯美古风漫画' },
];

export const mangaList: MangaItem[] = [
  {
    slug: 'doupo-cangqiong',
    title: '斗破苍穹',
    author: '天蚕土豆',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20young%20warrior%20with%20flame%20aura%20standing%20on%20cliff%20edge%2C%20dramatic%20lighting%2C%20fantasy%20martial%20arts%20theme%2C%20warm%20orange%20and%20red%20tones%2C%20epic%20composition%2C%20detailed%20ink%20brush%20style%20background%20with%20clouds%2C%20manga%20cover%20art%20quality%2C%20clean%20simple%20background%20with%20gradient&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后突然成了废人，种种打击接踵而至。就在他即将绝望的时候，一缕灵魂从他手上的戒指里浮现，一扇全新的大门在面前开启！这里是属于斗气的世界，没有花哨艳丽的魔法，有的，仅仅是繁衍到巅峰的斗气！',
    categories: ['热血', '玄幻', '古风'],
    status: '连载中',
    rating: 9.2,
    views: 12580000,
    chapters: 1520,
    updatedAt: '2026-08-04',
    tags: ['玄幻', '热血', '修炼', '戒指', '逆袭'],
    chapters_list: [
      { id: 1, title: '陨落的天才', updatedAt: '2019-01-15', pages: 24 },
      { id: 2, title: '斗气大陆', updatedAt: '2019-01-18', pages: 22 },
      { id: 1520, title: '最终决战·巅峰之路', updatedAt: '2026-08-04', pages: 28 },
    ],
  },
  {
    slug: 'yi-ren-zhi-xia',
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20mysterious%20young%20man%20with%20supernatural%20energy%20flowing%20around%20him%2C%20modern%20urban%20and%20traditional%20Chinese%20elements%20blend%2C%20yin%20yang%20symbol%20motif%2C%20stylish%20character%20design%2C%20cool%20green%20and%20gold%20color%20palette%2C%20clean%20simple%20background%20with%20subtle%20gradient&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    description: '随着爷爷尸体被盗，神秘少女冯宝宝的造访，少年张楚岚的平静校园生活被彻底颠覆。为了解开爷爷和自身身世的秘密，张楚岚和冯宝宝一起前往龙虎山天师府参加异人界的盛会——罗天大醮，与众多异人高手对战。',
    categories: ['热血', '都市', '玄幻'],
    status: '连载中',
    rating: 9.5,
    views: 18920000,
    chapters: 680,
    updatedAt: '2026-08-03',
    tags: ['异能', '现代', '热血', '冒险', '中国风'],
    chapters_list: [
      { id: 1, title: '神秘少女', updatedAt: '2015-02-26', pages: 20 },
      { id: 2, title: '异人世界', updatedAt: '2015-03-05', pages: 22 },
      { id: 680, title: '归一', updatedAt: '2026-08-03', pages: 26 },
    ],
  },
  {
    slug: 'quanzhi-gaoshou',
    title: '全职高手',
    author: '蝴蝶蓝',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20professional%20esports%20player%20with%20confident%20smile%20holding%20gaming%20mouse%2C%20dynamic%20cyber%20aesthetic%2C%20neon%20lights%20in%20background%2C%20cool%20blue%20and%20silver%20tones%2C%20stylish%20anime%20style%20character%20design%2C%20clean%20simple%20background&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐，离开职业圈的他寄身于一家网吧成了一个小小的网管。但是，拥有十年游戏经验的他，在荣耀新开的第十区重新投入了游戏，带着对往昔的回忆和一把未完成的自制银武千机伞，开始了重返巅峰之路。',
    categories: ['热血', '都市', '搞笑'],
    status: '已完结',
    rating: 9.3,
    views: 14250000,
    chapters: 360,
    updatedAt: '2024-12-20',
    tags: ['电竞', '游戏', '竞技', '热血', '逆袭'],
    chapters_list: [
      { id: 1, title: '被放逐的高手', updatedAt: '2015-08-01', pages: 22 },
      { id: 2, title: '第十区', updatedAt: '2015-08-08', pages: 20 },
      { id: 360, title: '荣耀之巅', updatedAt: '2024-12-20', pages: 30 },
    ],
  },
  {
    slug: 'wo-jia-da-shixiong-naozi-you-keng',
    title: '我家大师兄脑子有坑',
    author: '凌宇沫',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20funny%20style%20mischievous%20male%20cultivator%20with%20silly%20expression%2C%20comedic%20martial%20arts%20scene%2C%20bright%20vibrant%20colors%2C%20humorous%20anime%20style%2C%20light%20hearted%20composition%2C%20clean%20simple%20background%20with%20warm%20pastel%20gradient&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    description: '穿越到修仙世界却发现自己不在主角名单里？大师兄东方纤云表示：稳住，能苟！然而师弟师妹们个个都不是省油的灯，这个修仙界的日常，比他想象的还要刺激搞笑。',
    categories: ['搞笑', '玄幻', '古风'],
    status: '连载中',
    rating: 9.0,
    views: 8650000,
    chapters: 520,
    updatedAt: '2026-08-01',
    tags: ['修仙', '搞笑', '穿越', '日常', '轻松'],
    chapters_list: [
      { id: 1, title: '穿越第一天', updatedAt: '2017-05-10', pages: 18 },
      { id: 520, title: '大师兄的日常', updatedAt: '2026-08-01', pages: 20 },
    ],
  },
  {
    slug: 'tian-guan-ci-fu',
    title: '天官赐福',
    author: '墨香铜臭',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20beautiful%20ethereal%20male%20immortal%20in%20flowing%20white%20robes%20with%20flower%20petals%20floating%2C%20dreamy%20atmospheric%20ancient%20Chinese%20setting%2C%20soft%20golden%20and%20pink%20tones%2C%20romantic%20fantasy%20art%20style%2C%20delicate%20linework%2C%20clean%20simple%20background&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    description: '八百年前，谢怜是金枝玉叶的太子殿下。八百年后，谢怜是信徒寥寥的无名破烂神。在上天入地的旅途中，他遇见了那个红衣胜火的绝美鬼王花城。这是一个关于信仰、守护与救赎的故事。',
    categories: ['恋爱', '玄幻', '古风'],
    status: '已完结',
    rating: 9.7,
    views: 22300000,
    chapters: 240,
    updatedAt: '2025-06-15',
    tags: ['古风', '玄幻', '恋爱', '神仙', '唯美'],
    chapters_list: [
      { id: 1, title: '太子殿下', updatedAt: '2019-10-20', pages: 26 },
      { id: 240, title: '花开花谢终有时', updatedAt: '2025-06-15', pages: 32 },
    ],
  },
  {
    slug: 'zhen-hun-jie',
    title: '镇魂街',
    author: '许辰',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20dark%20fantasy%20warrior%20with%20ghostly%20guardian%20spirit%20behind%20him%2C%20urban%20supernatural%20theme%2C%20moody%20atmospheric%20lighting%2C%20dark%20purple%20and%20crimson%20tones%2C%20action%20pose%2C%20detailed%20ink%20art%20style%2C%20clean%20simple%20background&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    description: '镇魂街，此乃吸纳亡灵镇压恶灵之地。这是一个一个人灵共存的世界，只有拥有守护灵的寄灵人才可进入镇魂街。普通应届大学毕业生夏铃在求职之际误入罗刹街，从此展开了一段惊心动魄的冒险之旅。',
    categories: ['热血', '悬疑', '都市'],
    status: '连载中',
    rating: 9.1,
    views: 10120000,
    chapters: 480,
    updatedAt: '2026-07-28',
    tags: ['灵异', '守护灵', '战斗', '热血', '都市'],
    chapters_list: [
      { id: 1, title: '罗刹街', updatedAt: '2014-01-10', pages: 24 },
      { id: 480, title: '最终守护', updatedAt: '2026-07-28', pages: 26 },
    ],
  },
  {
    slug: 'dahuang-riji',
    title: '大荒日记',
    author: '七日',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20young%20girl%20in%20ancient%20Chinese%20dress%20with%20magical%20creature%20companion%2C%20whimsical%20fantasy%20world%2C%20soft%20watercolor%20style%2C%20warm%20earth%20tones%20and%20gentle%20greens%2C%20adventure%20theme%2C%20clean%20simple%20background&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    description: '少女苏小九意外穿越到神秘的大荒世界，这里妖兽横行、仙人出没。在这个光怪陆离的世界里，她用文字记录下每天的冒险与奇遇。一本日记，一段旅程，大荒的秘密正在慢慢揭开。',
    categories: ['玄幻', '恋爱', '古风'],
    status: '连载中',
    rating: 8.8,
    views: 5430000,
    chapters: 320,
    updatedAt: '2026-08-02',
    tags: ['穿越', '冒险', '古风', '玄幻', '日常'],
    chapters_list: [
      { id: 1, title: '穿越之初', updatedAt: '2020-03-15', pages: 20 },
      { id: 320, title: '大荒之秘', updatedAt: '2026-08-02', pages: 24 },
    ],
  },
  {
    slug: 'cike-wu-liutiao',
    title: '刺客伍六七',
    author: '何小疯',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20style%20quirky%20assassin%20with%20scissors%20weapon%2C%20funny%20expression%2C%20bright%20vibrant%20color%20palette%2C%20exaggerated%20cartoon%20style%2C%20warm%20and%20humorous%20tone%2C%20clean%20simple%20background%20with%20warm%20gradient&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    description: '在某个小岛上，有一个可以伪装成任何人的廉价刺客，名叫伍六七。伍六七平时看上去是个理发师，其实背地里却做着刺客生意。他的武器是一把剪刀，以各种奇葩方式完成刺杀任务，却总是搞出一堆爆笑乌龙。',
    categories: ['搞笑', '热血', '都市'],
    status: '连载中',
    rating: 9.4,
    views: 16800000,
    chapters: 180,
    updatedAt: '2026-07-30',
    tags: ['搞笑', '热血', '刺客', '日常', '治愈'],
    chapters_list: [
      { id: 1, title: '最强发型师', updatedAt: '2018-04-25', pages: 16 },
      { id: 180, title: '刺客的守则', updatedAt: '2026-07-30', pages: 20 },
    ],
  },
  {
    slug: 'mo-dao-zu-shi',
    title: '魔道祖师',
    author: '墨香铜臭',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20elegant%20male%20cultivator%20in%20black%20robes%20playing%20flute%2C%20mysterious%20moonlit%20night%20atmosphere%2C%20ancient%20Chinese%20aesthetic%2C%20dark%20red%20and%20black%20color%20scheme%2C%20refined%20art%20style%2C%20clean%20simple%20background&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    description: '夷陵老祖魏无羡死了，天下太平。十三年后，莫玄羽使用献舍禁术，令魏无羡重生于人间。再次面对往日的师门、故人和仇敌，这一世，他誓要揭开当年不夜天城之战的真相。',
    categories: ['玄幻', '恋爱', '悬疑'],
    status: '已完结',
    rating: 9.6,
    views: 25600000,
    chapters: 200,
    updatedAt: '2024-08-10',
    tags: ['修仙', '玄幻', '悬疑', '古风', '重生'],
    chapters_list: [
      { id: 1, title: '重生', updatedAt: '2018-07-09', pages: 28 },
      { id: 200, title: '忘机', updatedAt: '2024-08-10', pages: 34 },
    ],
  },
  {
    slug: 'xing-he-zhiguang',
    title: '星河之光',
    author: '星海',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20sci-fi%20style%20young%20astronaut%20and%20girl%20in%20space%20station%2C%20stars%20and%20galaxy%20background%2C%20futuristic%20romantic%20vibe%2C%20soft%20blue%20and%20purple%20cosmic%20tones%2C%20beautiful%20anime%20style%2C%20clean%20simple%20background%20with%20starry%20gradient&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    description: '2126年，人类已进入星际殖民时代。身为太空站机械师的少年林辰，在一次例行维修中意外救下了一名来自未知星域的神秘少女。她的出现，将彻底改变人类对宇宙的认知。一场横跨星河的爱情与冒险就此展开。',
    categories: ['科幻', '恋爱', '热血'],
    status: '连载中',
    rating: 8.9,
    views: 4200000,
    chapters: 160,
    updatedAt: '2026-07-25',
    tags: ['科幻', '星际', '恋爱', '冒险', '未来'],
    chapters_list: [
      { id: 1, title: '星际维修工', updatedAt: '2023-06-01', pages: 22 },
      { id: 160, title: '未知星域', updatedAt: '2026-07-25', pages: 24 },
    ],
  },
  {
    slug: 'tunshi-xingkong',
    title: '吞噬星空',
    author: '我吃西红柿',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20epic%20sci-fi%20warrior%20with%20energy%20armor%20fighting%20monsters%20in%20futuristic%20cityscape%2C%20dynamic%20action%20scene%2C%20metallic%20silver%20and%20blue%20tones%2C%20intense%20combat%20pose%2C%20detailed%20mecha%20design%2C%20clean%20simple%20background&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    description: '一场大灾难引起了地球上所有物种的变异。在人类与怪兽的对抗中，武者成为了人类最后的希望。少年罗峰经过重重考验，在武者的道路上越走越远，向着宇宙的巅峰冲击。',
    categories: ['科幻', '热血', '玄幻'],
    status: '连载中',
    rating: 9.0,
    views: 9870000,
    chapters: 620,
    updatedAt: '2026-08-01',
    tags: ['科幻', '末世', '变异', '战斗', '修炼'],
    chapters_list: [
      { id: 1, title: '大灾变', updatedAt: '2019-05-20', pages: 24 },
      { id: 620, title: '宇宙之主', updatedAt: '2026-08-01', pages: 26 },
    ],
  },
  {
    slug: 'mowang-buyao-tao',
    title: '魔王不要逃',
    author: '零度',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20romantic%20comedy%20style%20demon%20king%20and%20human%20girl%20in%20embarrassing%20situation%2C%20funny%20encounter%2C%20bright%20warm%20colors%2C%20light%20hearted%20anime%20style%2C%20school%20life%20and%20fantasy%20blend%2C%20clean%20simple%20background%20with%20pink%20gradient&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    description: '魔王大人为了逃避魔界的繁琐政务，偷偷跑到了人界。没想到第一天就被一个普通女高中生捡回了家。从此，曾经的万魔之主开始了寄人篱下的搞笑日常。可是魔界的追兵正在逼近……',
    categories: ['恋爱', '搞笑', '都市'],
    status: '连载中',
    rating: 8.7,
    views: 3890000,
    chapters: 200,
    updatedAt: '2026-07-20',
    tags: ['魔王', '恋爱', '搞笑', '校园', '日常'],
    chapters_list: [
      { id: 1, title: '魔王降临', updatedAt: '2022-08-15', pages: 18 },
      { id: 200, title: '归去来兮', updatedAt: '2026-07-20', pages: 22 },
    ],
  },
  {
    slug: 'guangmang-yu-heian',
    title: '光芒与黑暗',
    author: '白羽',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20detective%20story%20style%20young%20detective%20with%20magnifying%20glass%20in%20rainy%20city%20street%2C%20noir%20atmosphere%2C%20mysterious%20dark%20tone%2C%20silhouettes%20in%20shadows%2C%20suspenseful%20composition%2C%20clean%20simple%20background&width=400&height=560&seq=manga-cover-13&orientation=portrait',
    description: '城市中接连发生离奇案件，每一起都指向十年前的一桩悬案。刚毕业的警校高材生陈光与身份成谜的天才侦探叶暗，两人联手追查真相，却逐渐发现黑暗势力的触角远比他们想象的更加深远。',
    categories: ['悬疑', '都市', '热血'],
    status: '连载中',
    rating: 8.6,
    views: 3100000,
    chapters: 120,
    updatedAt: '2026-07-18',
    tags: ['悬疑', '侦探', '推理', '犯罪', '都市'],
    chapters_list: [
      { id: 1, title: '雨夜凶案', updatedAt: '2024-01-10', pages: 24 },
      { id: 120, title: '黑暗中的真相', updatedAt: '2026-07-18', pages: 26 },
    ],
  },
  {
    slug: 'huayao-xiaohun',
    title: '花妖小魂',
    author: '麦子',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20beautiful%20flower%20spirit%20girl%20with%20cherry%20blossom%20petals%2C%20ancient%20Chinese%20garden%20setting%2C%20soft%20pink%20and%20green%20pastel%20tones%2C%20delicate%20fairy%20tale%20atmosphere%2C%20gentle%20watercolor%20art%20style%2C%20clean%20simple%20background&width=400&height=560&seq=manga-cover-14&orientation=portrait',
    description: '一朵修炼千年的牡丹花妖，化为人形来到人间。她遇到了一个温柔的画师，两人在花开花落间慢慢走近。奈何天道有常，人妖殊途，一段跨越种族的唯美爱情故事悄然上演。',
    categories: ['恋爱', '古风', '玄幻'],
    status: '已完结',
    rating: 9.1,
    views: 5670000,
    chapters: 150,
    updatedAt: '2025-03-20',
    tags: ['恋爱', '古风', '花妖', '唯美', '玄幻'],
    chapters_list: [
      { id: 1, title: '花开时节', updatedAt: '2021-04-05', pages: 20 },
      { id: 150, title: '花落归尘', updatedAt: '2025-03-20', pages: 28 },
    ],
  },
  {
    slug: 'liekong-zhanji',
    title: '裂空战纪',
    author: '烽火',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20action%20style%20armored%20warrior%20with%20giant%20sword%20facing%20dragon%20in%20epic%20battlefield%2C%20fantasy%20war%20theme%2C%20dramatic%20red%20and%20gold%20tones%2C%20cinematic%20composition%2C%20intense%20fighting%20pose%2C%20clean%20simple%20background&width=400&height=560&seq=manga-cover-15&orientation=portrait',
    description: '天裂之战后，人族与龙族的和平契约被打破。年轻的龙骑士洛辰肩负起守护人族最后城池的使命。在血与火的洗礼中，他将成长为传说中能够裂开苍穹的战士。',
    categories: ['热血', '玄幻', '科幻'],
    status: '连载中',
    rating: 8.5,
    views: 2890000,
    chapters: 280,
    updatedAt: '2026-07-15',
    tags: ['战争', '龙', '骑士', '热血', '战斗'],
    chapters_list: [
      { id: 1, title: '天裂', updatedAt: '2022-11-12', pages: 26 },
      { id: 280, title: '裂空一击', updatedAt: '2026-07-15', pages: 28 },
    ],
  },
  {
    slug: 'bang-bang-tang',
    title: '棒棒糖与青春',
    author: '糖果小姐',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cute%20high%20school%20students%20sharing%20lollipops%20under%20cherry%20blossom%20tree%2C%20sweet%20youth%20romance%20theme%2C%20soft%20pastel%20pink%20and%20blue%20colors%2C%20heartwarming%20school%20life%20style%2C%20clean%20simple%20background&width=400&height=560&seq=manga-cover-16&orientation=portrait',
    description: '从小学到高中，林糖糖的座位旁边总是坐着同一个男孩——陈墨。一根棒棒糖、一张小纸条、一次不经意的四目相对...青春里最甜蜜的暗恋，在毕业季的花瓣雨中终于迎来了答案。',
    categories: ['恋爱', '搞笑', '都市'],
    status: '已完结',
    rating: 9.0,
    views: 4560000,
    chapters: 100,
    updatedAt: '2024-11-30',
    tags: ['校园', '恋爱', '青春', '暗恋', '治愈'],
    chapters_list: [
      { id: 1, title: '同桌的你', updatedAt: '2022-03-01', pages: 16 },
      { id: 100, title: '毕业告白', updatedAt: '2024-11-30', pages: 24 },
    ],
  },
];

export const getMangaByCategory = (categorySlug: string): MangaItem[] => {
  const category = mangaCategories.find(c => c.slug === categorySlug);
  if (!category) return [];
  return mangaList.filter(manga => manga.categories.includes(category.name));
};

export const getMangaBySlug = (slug: string): MangaItem | undefined => {
  return mangaList.find(manga => manga.slug === slug);
};

export const getHotManga = (): MangaItem[] => {
  return [...mangaList].sort((a, b) => b.views - a.views).slice(0, 8);
};

export const getLatestManga = (): MangaItem[] => {
  return [...mangaList].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 8);
};